export default __webpack_public_path__ + "static/media/Google_Play_Store_badge_EN.svg.30cb6301.webp";